<template>
  <section class="room" v-if="isStandard">
    <p class="plan">plan {{ plan }}</p>
    <p class="room-type">
      {{ roomType }}<span class="best-deal">Best deal</span>
    </p>
    <div class="card">
      <section class="images">
        <carousel
          :perPage="1"
          paginationActiveColor="#FFFFFF"
          paginationColor="rgba(255, 255, 255, 0.8)"
          :paginationSize="8"
          :paginationPadding="3"
          :autoplay="false"
          :navigationEnabled="true"
          navigationNextLabel=""
          navigationPrevLabel=""
          :loop="true"
        >
          <slide
            v-for="(image, index) in hotelImages"
            :key="`hotel-image-${index}`"
          >
            <img :src="image" :alt="`hotel-image-${index}`" />
          </slide>
        </carousel>
      </section>
      <div class="plan-room-type">
        <!-- <p class="plan">plan {{plan}}</p> -->
        <p class="room-type">{{ roomType }}</p>
      </div>
      <!-- <div class="people">
        <img src="@/assets/hotel-detail/ic_people.svg" alt="">
        <p>People:</p>
        <select>
          <option value="1">1</option>
          <option value="2">2</option>
          <option value="3">3</option>
          <option value="4">4</option>
        </select>
      </div> -->
      <!-- <div class="room-info">
        <p>26 square meters</p>
        <p>Room for two people</p>
        <a href="#">more details</a>
      </div> -->
      <div class="price">
        <div class="per-night">
          <p>Price per night</p>
          <p>{{ room.price }}€</p>
          <span class="best-deal">Best deal</span>
        </div>
        <div class="total">
          <div class="rooms-nights">
            <p>Total price</p>
            <p>
              {{ people }} room, <br />
              {{ nights }} nights stay
            </p>
          </div>
          <p class="price-calc">{{ totalPrice }}€</p>
        </div>
        <div class="total lg">
          <p>Total price</p>
          <p class="price-calc">{{ totalPrice }}€</p>
          <p>{{ people }} room, {{ nights }} nights stay</p>
        </div>
      </div>
      <a
        :href="bookingURL"
        target="_blank"
        rel="noopener noreferrer"
        class="btn btn-primary"
        >Book now</a
      >
      <p class="more-info">More info</p>
      <div class="reservation-info">
        <p
          v-for="(includedRate, i) in includedRates"
          :key="`includedRate+${i}`"
        >
          {{ showIncludedRates(includedRate) }}
        </p>
      </div>
    </div>
  </section>
</template>

<script>
import { getRoomType } from "@/helpers/rooms";
import { mapGetters } from "vuex";

import { Carousel, Slide } from "vue-carousel";

export default {
  components: {
    Carousel,
    Slide
  },
  props: {
    room: Object,
    plan: Number,
    hotelName: String,
    hotelImages: Array,
    bookingURL: String
  },
  data: function() {
    return {
      nights: 4,
      people: 1
    };
  },
  computed: {
    ...mapGetters(["includedRates"]),
    roomType: function() {
      return getRoomType({
        hotelName: this.hotelName,
        roomName: this.room.name
      });
    },
    totalPrice: function() {
      return (this.room.price * this.nights * this.people).toFixed(2);
    },

    // eslint-disable-next-line vue/return-in-computed-property
    isStandard: function() {
      if (this.roomType === "Standard Room") {
        return true;
      }
    }
  },
  methods: {
    showIncludedRates(rate) {
      if (rate === "breakfast") {
        return "Breakfast included";
      } else if (rate === "vat10") {
        return "VAT included";
      } else if (rate === "touristCityTax") {
        return "Tourist tax included";
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/scss/vendor/vue-carousel.scss";
@import "@/scss/color-mixin.scss";

.room {
  margin: 0;

  & > p {
    margin: 0 20px;
  }

  p.plan {
    font-size: 18px;
    text-transform: uppercase;
  }

  p.room-type {
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 10px;
  }

  span.best-deal {
    background: var(--congress-color);
    border-radius: 14px;
    font-size: 14px;
    color: #ffffff;
    padding: 0 16px;
    margin-left: 16px;
    height: 22px;
    display: inline-block;
    line-height: 22px;
  }

  .card {
    margin: 0 10px 40px 10px;
    min-height: 430px;
    border: 1px solid #e9e9e9;
    border-radius: 5px;

    .images {
      margin: 0 0 20px 0;

      img {
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
      }
    }

    .plan-room-type {
      display: none;
    }

    .room-info {
      display: none;
    }

    .price {
      margin: 0 20px 30px 20px;

      .per-night {
        margin-bottom: 20px;
        display: flex;
        justify-content: space-between;
        p {
          font-weight: 600;
          font-size: 16px;
          align-self: center;
        }

        p:last-child {
          font-weight: bold;
          font-size: 26px;
        }

        span.best-deal {
          display: none;
        }
      }

      .total {
        display: flex;
        justify-content: space-between;

        .rooms-nights {
          font-size: 14px;

          p:first-child {
            text-transform: uppercase;
            font-weight: bold;
          }
        }
        p.price-calc {
          font-weight: bold;
          font-size: 30px;
          align-self: center;
        }
      }

      .total.lg {
        display: none;
      }
    }

    a.btn.btn-primary {
      line-height: 40px;
      height: 40px;
      color: white;
      margin: 0 20px 30px 20px;
      display: block;
      background-color: var(--congress-color);

      &:hover {
        background-color: var(--congress-color-hover);
      }
    }

    p.more-info {
      margin: 0 20px;
      font-size: 14px;
      font-weight: bold;
      text-align: right;

      &::after {
        content: url("../../assets/filters-icons/ic_button_deactive_dropdown_active_down.svg");
      }
    }

    .reservation-info {
      display: none;
    }
  }
}

@media (min-width: 768px) {
  .room {
    > p.plan,
    > p.room-type > span {
      display: none;
    }

    p.room-type {
      margin-left: 0;
    }

    .card {
      margin-left: 0;
      min-height: 340px;
      display: grid;
      grid-template-columns: 32% 25% 23% 20%;
      grid-template-rows: 25% 35% 40%;
      grid-template-areas:
        "images roomType . reserve"
        "images people details reserve"
        "images VATBreak VATBreak reserve";

      .images {
        grid-area: images;
        width: 380px;
        padding: 30px;
        margin-bottom: 0;

        img {
          height: 280px;
          width: 320px;
        }
      }

      .plan-room-type {
        grid-area: roomType;
        display: block;
        padding-top: 30px;
      }

      .people {
        grid-area: people;
        margin: 0;
        padding-bottom: 50px;
        padding-right: 75px;
        align-self: end;
        align-items: center;
        border: none;

        p {
          font-size: 20px;
        }

        img {
          margin-left: 0;
        }
      }

      .room-info {
        display: block;
        grid-area: details;
        align-self: end;
        padding-bottom: 7px;
        padding-left: 80px;
        border-left: 1px solid #e9e9e9;

        p {
          font-size: 20px;
        }

        a {
          text-decoration: none;
          color: $primary-black;
          font-weight: bold;

          &::after {
            content: url("../../assets/hotel-detail/ic_button_deactive_dropdown_active_right.svg");
            margin-left: 10px;
          }

          &:hover {
            text-decoration: underline;
          }
        }
      }

      .price {
        grid-area: reserve;
        margin-left: 47px;
        border-left: 1px solid #e9e9e9;
        margin-bottom: 0;

        div.per-night {
          flex-direction: column-reverse;
          align-content: flex-end;

          p:first-child {
            font-size: 14px;
            text-transform: uppercase;
            font-weight: 600;
          }

          p {
            align-self: flex-end;
            font-weight: bold;
            font-size: 26px;
          }

          span.best-deal {
            display: block;
            min-width: 107px;
            min-height: 28px;
            font-weight: bold;
            line-height: 28px;
            text-align: center;
            align-self: flex-end;
            margin-top: 40px;
            margin-bottom: 10px;
          }
        }

        .total {
          display: none;
        }

        .total.lg {
          display: flex;
          flex-direction: column;
          align-items: flex-end;

          p:first-child {
            text-transform: uppercase;
            font-weight: 600;
            font-size: 18px;
          }

          p.price-calc {
            align-self: flex-end;
            font-size: 33px;
          }

          p:last-child {
            font-size: 14px;
            text-transform: uppercase;
            font-weight: 600;
          }
        }
      }

      a.btn.btn-primary {
        grid-area: reserve;
        align-self: end;
        justify-self: end;
        width: 130px;
        margin-left: 60px;
        margin-right: 20px;
      }

      .more-info {
        display: none;
      }

      .reservation-info {
        display: block;
        grid-area: VATBreak;
        border-top: 1px solid #e9e9e9;
        margin-top: 28px;
        padding-top: 28px;

        p:before {
          margin-right: 5px;
          vertical-align: sub;
          content: var(--congress-icon-check);
        }
      }
    }
  }
}
</style>
